import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { GUIDES } from "@/lib/guides";

const CATEGORIES = [
  { to: "/agricultural-land", label: "Agricultural Land" },
  { to: "/plots", label: "Open Plots" },
  { to: "/homes", label: "Homes & Houses" },
  { to: "/commercial", label: "Commercial" },
];

export function SeoLinks() {
  const { data: locations = [] } = useQuery({
    queryKey: ["locations"],
    queryFn: async () => (await api.get("/locations")).data,
  });
  const topLocations = locations.slice(0, 8);

  return (
    <section className="mt-16 border-t border-slate-200 pt-10" data-testid="seo-links">
      <div className="grid sm:grid-cols-3 gap-8 text-sm">
        <div>
          <h2 className="font-heading font-bold text-slate-900 mb-3">Browse by category</h2>
          <ul className="space-y-2">
            {CATEGORIES.map((c) => (
              <li key={c.to}><Link to={c.to} className="text-slate-600 hover:text-emerald-700">{c.label} for sale in Telangana</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h2 className="font-heading font-bold text-slate-900 mb-3">Popular locations</h2>
          <ul className="space-y-2">
            {topLocations.map((l) => (
              <li key={l.slug}><Link to={`/location/${l.slug}`} className="text-slate-600 hover:text-emerald-700">Property in {l.name}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h2 className="font-heading font-bold text-slate-900 mb-3">Property & land guides</h2>
          <ul className="space-y-2">
            {GUIDES.map((g) => (
              <li key={g.slug}><Link to={`/guides/${g.slug}`} className="text-slate-600 hover:text-emerald-700">{g.linkText}</Link></li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
